/* tslint:disable */
import { injectGlobal } from 'styled-components'
import reset from 'styled-reset'

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Maven+Pro:400,500');
  ${reset};
  body {
    font-family: 'Maven Pro', sans-serif;
  }
  a {
      color:inherit;
  }
`


// WEBPACK FOOTER //
// ./src/globalStyles.ts